export default function topics() {

  const $categories = $('.tags .tag');
  const $button = $('.see-all-btn');

  // Show only the first 10 categories by default (only on mobile)
  if ($(window).width() <= 768) {
    $categories.slice(10).hide();
    $button.show();
  } else {
    $button.hide();
  }

  $(window).resize(function () {
    // Show only the first 10 categories on mobile, show all categories on desktop
    if ($(window).width() <= 768) {
      $categories.slice(10).hide();
      $button.show();
    } else {
      $categories.show();
      $button.hide();
    }
  });

  $button.click(function () {
    $categories.slice(10).slideToggle();
    $(this).toggleClass('open');
    $(this).text($(this).text() == '全て開く' ? '一部だけ表示' : '全て開く');
  });
}
